const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B5F1F4"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M511.598,270.252L354.251,113.435l-133.877-24.08l-88.495,88.495L92.313,308.889l199.913,200.547 C411.85,492.491,504.868,392.873,511.598,270.252z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M329.266,385.293h-44.822V366.33h44.822c17.11,0,31.03-13.921,31.03-31.03v-44.822h18.963V335.3 C379.259,362.867,356.833,385.293,329.266,385.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M390.465,290.478h-41.374v-85.333c0-51.331-41.76-93.091-93.091-93.091s-93.091,41.76-93.091,93.091 v85.333h-41.374v-85.333c0-74.143,60.321-134.465,134.465-134.465s134.465,60.321,134.465,134.465V290.478z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M167.65,318.923h-51.141c-18.884,0-34.19-15.308-34.19-34.19v-45.396 c-0.002-18.884,15.307-34.192,34.19-34.192h51.141V318.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M82.316,262.322v22.411c0,18.882,15.308,34.19,34.192,34.19h51.141v-56.601L82.316,262.322 L82.316,262.322z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.222,
    y: 205.145,
    style: {
      fill: "#FC6F58"
    },
    width: 28.444,
    height: 113.778
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M344.35,205.145h51.143c18.884,0,34.192,15.308,34.192,34.192v45.396 c0,18.884-15.308,34.19-34.19,34.19h-51.143L344.35,205.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M344.35,262.322v56.601h51.141c18.884,0,34.192-15.308,34.192-34.19v-22.411L344.35,262.322 L344.35,262.322z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.333,
    y: 205.145,
    style: {
      fill: "#FC6F58"
    },
    width: 28.444,
    height: 113.778
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.222,
    y: 262.327,
    style: {
      fill: "#F1543F"
    },
    width: 28.444,
    height: 56.601
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.333,
    y: 262.327,
    style: {
      fill: "#F1543F"
    },
    width: 28.444,
    height: 56.601
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6F58"
    },
    d: "M225.566,396.498h53.97c8.661,0,15.681-7.021,15.681-15.681v-10.011 c0-8.661-7.021-15.681-15.681-15.681h-53.97c-8.661,0-15.681,7.021-15.681,15.681v10.011 C209.886,389.477,216.907,396.498,225.566,396.498z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.109f55d6366579c9bd10ee8f9ff1d115.svg";
export { ForwardRef as ReactComponent };